module.exports = __webpack_public_path__ + "media/images/icons/material/location-c4b38540643736deab29990041453db6.svg";